<template>
    <div :class="classNames">
        <a
            :href="post.permalink"
            target="_blank"
            :title="post.caption_excerpt"
            class="w-full h-full"
            @click="trackAnalytics">
            <responsive-image
                class="w-full h-full object-cover"
                :image="{ srcset:post.src_set, url:post.media_url, width:null }"
                :fallback-image="post.media_url"
                :alt="post.caption_excerpt"
            />
        </a>
    </div>
</template>

<script>
import Vue from 'vue';
import ResponsiveImage from '@web/components/ResponsiveImage';

export default {
  name: 'InstagramCell',
  components: {
    ResponsiveImage,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cellNumber() {
      let cellNumber = this.index + 1;
      if (cellNumber === 14) {
        cellNumber = 15;
      }
      return cellNumber;
    },
    classNames() {
      return `cell-${this.cellNumber}${(this.cellNumber > 3) ? ' phone:hidden' : ''}${(this.cellNumber === 15) ? ' hidden hd:block imac:hidden' : ''}`;
    },
  },
  methods: {
    trackAnalytics() {
      Vue.analytics.trackWebsiteEvent('Visited Instagram Post', {
        'Post Url': this.post.permalink,
      });
    },
  },
};
</script>

<style scoped>

</style>
